import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import Varient from './variants';
import usePDPData from '../../_utils/use-pdp-data';
import PDPBreadcrumb from '../breadcrumb/pdp-breadcrumb';
import ShareButton from '../buttons/share/share-button';
import WishlistButton from '../buttons/wishlist-button/wishlist-button';
import ProductStats from '../product-stats';
const ProductDetails = () => {
  const {
    isMobile
  } = useMobileDetect();
  const {
    data
  } = usePDPData();
  const productTitle = data?.pageH1 || `${data?.nameFa} ${data?.brand?.nameFa}`;
  return <div className='flex w-full grow flex-col' data-sentry-component="ProductDetails" data-sentry-source-file="product-details.tsx">
            <div className='mb-1.5 flex items-center justify-between lg:mb-4'>
                <PDPBreadcrumb data-sentry-element="PDPBreadcrumb" data-sentry-source-file="product-details.tsx" />

                <div className='flex gap-3 lg:hidden'>
                    <WishlistButton data-sentry-element="WishlistButton" data-sentry-source-file="product-details.tsx" />
                    <ShareButton data-sentry-element="ShareButton" data-sentry-source-file="product-details.tsx" />
                </div>
            </div>

            <div className='mb-3 flex h-fit flex-col gap-2 lg:mb-5'>
                <h1 className='text-body-16 font-medium text-text-black'>{productTitle}</h1>
                <span className='hidden text-body-14 font-medium text-text-mediumGray lg:flex'>{data?.nameEn}</span>
            </div>

            {isMobile && <ProductStats />}

            <Varient data-sentry-element="Varient" data-sentry-source-file="product-details.tsx" />
        </div>;
};
export default ProductDetails;